import { useEffect, useState } from 'react';

const downloadLinkUrls = {
    'Android': 'https://play.google.com/store/apps/details?id=com.followone.app&hl=en',
    'iOS': 'https://itunes.apple.com/us/app/followone/id1439219757?mt=8',
    'Windows Phone': 'https://followone.com',
    'unknown': 'https://followone.com',
}

const DownloadApp = props => {

    const [downloadLink] = useState(downloadLinkUrls);

    useEffect(() => {
        window.scrollTo(0, 0);

        let t = downloadLink[getMobileOperatingSystem()];

        if (!t) {
            return;
        }

        window.location.href = t;
    }, [downloadLink])


    const getMobileOperatingSystem = () => {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;

        // Windows Phone must come first because its UA also contains "Android"
        if (/windows phone/i.test(userAgent)) {
            return "Windows Phone";
        }

        if (/android/i.test(userAgent)) {
            return "Android";
        }

        // iOS detection from: http://stackoverflow.com/a/9039885/177710
        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            return "iOS";
        }

        return "unknown";
    }

    return null;
}

export default DownloadApp;